import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { Check, Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 px-4 relative" data-id="element-230">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-231" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-232">
        <div className="text-center mb-12" data-id="element-233">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-234">ELEGÍ TU PACK</h2>
        </div>

        <CountdownTimer data-id="element-235" />

        <div className="grid md:grid-cols-2 gap-8 mt-12 max-w-4xl mx-auto" data-id="element-236">
          {/* Basic Pack */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-white/10 rounded-3xl p-8 flex flex-col" data-id="element-237">
            <div className="mb-6" data-id="element-238">
              <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-239">
                📦 PACK ¿QUÉ COMEMOS HOY?
              </h3>
              <p className="text-gray-400 text-sm h-10" data-id="element-240">
                Para cualquier hogar argentino que quiera resolver la comida
                diaria
              </p>
            </div>

            <div className="mb-8 flex-grow" data-id="element-241">
              <ul className="space-y-3" data-id="element-242">
                <li className="flex items-center gap-3" data-id="element-243">
                  <Check className="w-5 h-5 text-brand-gold" data-id="element-244" /> 6 Tomos
                  Completos
                </li>
                <li className="flex items-center gap-3" data-id="element-245">
                  <Check className="w-5 h-5 text-brand-gold" data-id="element-246" /> 6 Bonos
                  Exclusivos
                </li>
              </ul>
            </div>

            <div className="mb-8" data-id="element-247">
              <div className="text-gray-500 line-through text-lg mb-1" data-id="element-248">
                $68.000
              </div>
              <div className="text-4xl font-bold text-white flex items-baseline gap-2" data-id="element-249">
                $17.990 <span className="text-xl text-brand-gold" data-id="element-250">ARS</span>
              </div>
            </div>

            <Button variant="outline" fullWidth className="py-4" onClick={() => window.open('https://www.bibliotecasdigitales.store/checkouts/cn/hWNB77rzlDfrnT8Rg8IdchHu/es-ar?_r=AQABVf-B6bB72M1QNGEUVofnoUoOpJD2Jn4ZxVvQ47AfyLw&cart_link_id=W58G0UCK&locale=es-AR&preview_theme_id=154123698339', '_blank')} data-id="element-251">
              <span className="mr-2" data-id="element-252">🔴</span> QUIERO MI PACK AHORA
            </Button>
          </motion.div>

          {/* Premium Pack */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-b from-brand-card to-brand-darker border-2 border-brand-gold rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(212,160,23,0.15)]" data-id="element-253">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-black font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 whitespace-nowrap" data-id="element-254">
              <Star className="w-4 h-4 fill-black" data-id="element-255" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-256">
              <h3 className="text-2xl font-bold mb-2 flex items-center gap-2 text-brand-gold" data-id="element-257">
                🏆 PACK COMPLETO + MÉTODO CHANGO LLENO
              </h3>
              <p className="text-gray-300 text-sm h-10" data-id="element-258">
                Para quien quiere resolver la comida Y reducir el gasto mensual
                entre un 30% y un 50%
              </p>
            </div>

            <div className="mb-8 flex-grow" data-id="element-259">
              <ul className="space-y-3" data-id="element-260">
                <li className="flex items-center gap-3" data-id="element-261">
                  <Check className="w-5 h-5 text-brand-gold" data-id="element-262" /> 6 Tomos
                  Completos
                </li>
                <li className="flex items-center gap-3" data-id="element-263">
                  <Check className="w-5 h-5 text-brand-gold" data-id="element-264" /> 6 Bonos
                  Exclusivos
                </li>
                <li className="flex items-start gap-3 bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20 mt-4" data-id="element-265">
                  <Star className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-266" />
                  <span className="font-medium" data-id="element-267">
                    Estrategia de Ahorro en Supermercado (Método Chango Lleno)
                  </span>
                </li>
              </ul>
            </div>

            <div className="mb-8" data-id="element-268">
              <div className="text-gray-500 line-through text-lg mb-1" data-id="element-269">
                $90.000
              </div>
              <div className="text-5xl font-bold text-white flex items-baseline gap-2" data-id="element-270">
                $27.990 <span className="text-xl text-brand-gold" data-id="element-271">ARS</span>
              </div>
            </div>

            <Button variant="primary" fullWidth className="py-4 text-lg" onClick={() => window.open('https://www.bibliotecasdigitales.store/checkouts/cn/hWNB78QLSSrer4OVYywHZACw/es-ar?_r=AQABNhPiEa787tTn-OxeMBhcgxKUnjPjt4qe1OxU6mnkbuA&cart_link_id=wzK5MD8v&locale=es-AR&preview_theme_id=154123698339', '_blank')} data-id="element-272">
              <span className="mr-2" data-id="element-273">🔴</span> QUIERO EL PACK + AHORRO
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}